import { fabric, LayerManager, eventStatus, generalEvent, toolsConfig } from '@aibee/vincent';

const { makeGraphics } = generalEvent;

function pointConverter(pointDict, graphic_list) {
  // 将数据分组
  const groupPointData = graphic_list.reduce((t, c) => {
    if (c.group_type === 'LinePoint') {
      if (t[c.group_id]) {
        const gdata = t[c.group_id];
        if (gdata.some(g => g.graphic_id === c.graphic_id)) {
          console.log(`数据重复=>group_id:${c.group_id},graphic_id:${c.graphic_id}`);
        } else {
          t[c.group_id].push(c);
        }
      } else {
        t[c.group_id] = [c];
      }
    } else if (c.graphic_type === 'point') {
      t[c.graphic_id] = c;
    }
    return t;
  }, {});
  Object.keys(groupPointData).forEach((key) => {
    const item = groupPointData[key];
    // 不是LinePoint分组数据
    if (!Array.isArray(item)) {
      if (item.graphic_data.length <= 0) return;
      if (item.group_type === 'PanoramaPoint') {
        // 全景点其他地方已经渲染过了，这里只修改保存的property
        const sel = LayerManager.getCurrentLayer().getAllObjects().filter(obj => obj.type === 'PanoramaPoint' && obj.property && obj.property.pano_id === item.property.pano_id);
        if (sel && sel.length > 0) {
          Object.assign(sel[0].property, item.property);
          // 保存全景点原始uuid
          sel[0].uuid = item.graphic_id;
        }
      } else {
        // 回显渲染直梯、扶梯、大屏、其他无分组单体类型数据
        const pointXY = pointDict[key];
        // console.log(pointXY);
        item.group_type = item.group_type || 'CirclePoint';
        let config = toolsConfig.toolList.find(t => t.type === item.group_type) || {};
        config = JSON.parse(JSON.stringify(config));
        Object.assign(config.shapeParams, { left: pointXY.x, top: pointXY.y, uuid: pointXY.uuid, property: item.property });
        config.uuid = pointXY.uuid;
        LayerManager.getCurrentLayer().addObject(item.group_type, config);
      }
    } else {
      // LinePoint分组类型处理
      if (item.length <= 0) return;
      item.sort((a, b) => a.sequence_id - b.sequence_id);
      const pointXYArr = item.map((point) => {
        const gt = pointDict[point.graphic_id];
        // 注入property
        if (gt && typeof gt === 'object') {
          gt.property = point.property;
        }
        return gt;
      }).filter(t => t);
      // console.log(pointXYArr, item);
      // const properties = item.reduce((t, c) => { t[c.graphic_id] = c.property; return t; }, {});
      if (pointXYArr.length > 0) {
        makeGraphics('LinePoint', {}, { points: pointXYArr, uuid: key, importData: item }, false);
      }
    }
  });
  eventStatus.reset();
}
// function lineConverter(pointDict, lineData) {
//   lineData.forEach((item) => {
//     if (item.graphic_data.length < 2) return;
//     const point1 = pointDict[item.graphic_data[0]];
//     const point2 = pointDict[item.graphic_data[1]];
//     const line = makeGraphics('CommonLine', {}, [{ x: point1.x, y: point1.y }, { x: point2.x, y: point2.y }], false);
//     line.property = item.property || {};
//   });
//   eventStatus.reset();
// }
function polygonConverter(pointDict, polygonData) {
  polygonData.forEach((item) => {
    if (item.graphic_data.length < 3) return;
    const pointArr = item.graphic_data.map(point => ({ ...pointDict[point], uuid: point }));
    const polygon = makeGraphics('SkeletonPolygon', pointArr[0], { points: pointArr, uuid: item.graphic_id }, false);
    polygon.property = item.property || {};
  });
  eventStatus.reset();
}
function svgConverter() {
  fabric.loadSVGFromURL('https://static.aibee.cn/media/ceph1/dataset/upload/1_17.svg', (objects, options) => {
    const currentLayer = LayerManager.getCurrentLayer();
    const obj = fabric.util.groupSVGElements(objects, options);
    currentLayer.canvas.add(obj);
    obj.activeSelect();
    currentLayer.unGroup();
    currentLayer.discardActiveObject();
  });
}
// 给原型传入url生成BgImage会出现bug
function makeBgImage(url) {
  const imageEle = document.createElement('img');
  const tools = toolsConfig.getTools();
  let config = tools.find(item => item.type === 'BgImage') || {};
  config = JSON.parse(JSON.stringify(config));
  config.img_url = url;
  imageEle.src = url;
  imageEle.onload = () => {
    const currentLayer = LayerManager.getCurrentLayer();
    config.element = imageEle;
    // 为了使图片不在图层中显示
    const bgImage = currentLayer.addObject('BgImage', config, true);
  };
}
export default function mainConverter({ point_dict = {}, graphic_list = [], image_url }) {
  const pointList = graphic_list.filter(item => item.graphic_type === 'point');
  const lineList = graphic_list.filter(item => item.graphic_type === 'line');
  const polygonList = graphic_list.filter(item => item.graphic_type === 'polygon');
  makeBgImage(image_url);
  // makeGraphics('BgImage', {}, { image_url }, false);
  pointConverter(point_dict, graphic_list);
  // lineConverter(point_dict, lineList);
  polygonConverter(point_dict, polygonList);
  // svgConverter();
  LayerManager.getCurrentLayer().getAllObjects().forEach((item) => {
    if (item.type === 'CirclePoint') {
      item.bringToFront();
    }
  });
}
